import { api } from '~/data/api'
import { IChangeWorskpaceResponse } from '~/utils/types'

export async function loginUser(email: string, password: string) {
  const response = await api().post('/login', { email, password })

  return response.data
}

export async function recoverPassword(email: string) {
  const response = await api().post('/forgot-password', { email })

  return response.data
}

export async function resetPassword(password: string, token: string) {
  const response = await api().put(
    `/reset-password`,
    { password },
    { headers: { Authorization: 'Bearer ' + token } },
  )

  return response.data
}

export async function updatePassword(password: string, identityId: string) {
  const response = await api().patch(`/identity/${identityId}`, { password })

  return response.data
}

export async function loginWithSalesforce(code: string) {
  const response = await api().post('/login-salesforce', { code })

  return response.data
}

export async function checkTokenActive(token: string): Promise<boolean> {
  const response = await api().post('/check-token', {
    token,
  })

  return Boolean(response.data?.is_active)
}

export async function resendPin(mfa_access_token: string) {
  const response = await api().post('/resend-pin', { mfa_access_token })

  return response
}

export async function checkPin(mfaAccessToken: string, pin: string) {
  const response = await api().post('/check-pin', {
    mfa_access_token: mfaAccessToken,
    pin,
  })

  return response.data
}

export async function loginMicrosoft(accountToken: string) {
  const response = await api().post('/login-microsoft', { account_token: accountToken })

  return response.data
}

export async function selectWorkspace(selectWorkspaceToken: string, workspaceId: string) {
  const response = await api().post('/auth/select-workspace', {
    select_workspace_token: selectWorkspaceToken,
    selected_user_id: workspaceId,
  })

  return response.data
}

export async function changeWorkspace(): Promise<IChangeWorskpaceResponse> {
  const response = await api().post('/auth/change-workspace')

  return response.data
}

export async function loginGoogle(accessToken: string) {
  const response = await api().post('/login-google', { access_token: accessToken })

  return response.data
}

export interface IImpersonationIdentity {
  identity_id: string
  name: string
  email: string
  workspaces: {
    id: string
    workspace_name: string | null
    company_id: string
    company_name: string
    profile: string
    active: boolean
    profile_picture: string
    company_picture: string
  }[]
}

export async function searchIdentitiesForImpersonation(
  query: string,
): Promise<IImpersonationIdentity[]> {
  const response = await api().get('/auth/impersonate/search', { params: { query } })

  return response.data
}

export async function impersonateUser(targetUserId: string) {
  const response = await api().post('/auth/impersonate', { target_user_id: targetUserId })

  return response.data
}

export async function stopImpersonation() {
  const response = await api().post('/auth/stop-impersonate')

  return response.data
}
